import expandLogo from '../../../assets/images/Expand Arrow1.png';



export default function AgentInput (props) {
    
    let { handleOnChange, selectFollower, setFollow, userData, follow, agentData, expand, updateAgent, showNewEquation, setShowNewEquation } = props;
    
    return(
        <div className='flex justify-between pb-6 border-b-2 w-[90%] mt-6'>
                        
                            <div className='flex justify-between w-[30%]'>
                                <input 
                                    
                                    type='text' 
                                    name='agentName' 
                                    onChange={(e) => handleOnChange(e)} 
                                    value={agentData.agentName} 
                                    placeholder='Agent Name' 
                                    className='me-6 bg-bgColor text-fgColor py-2 ps-4 w-[200px] outline-none font-semibold rounded-md' 
                                />

                                <div className='bg-bgColor text-fgColor py-2 ps-4 w-[230px] flex items-center justify-between  cursor-pointer font-semibold rounded-md relative'
                                    onClick={(e) => selectFollower(e)}>
                                    <div> 
                                        { follow.name }
                                    </div>
                                    <img src={expandLogo} alt="Expand-logo" className='' />
                                    {
                                        expand ?
                                            <div className="bg-bgColor text-fgColor w-[230px] absolute top-[45px] left-0 cursor-pointer overflow-auto h-[200px] z-40">
                                                {
                                                    userData.map((user) => (
                                                        <div key={user.userId}
                                                            className={`${user.userId != user.length ? "border-b-2 " : "border-b-0"}  py-2
                                                                        px-4 hover:bg-primary hover:text-rectangle transition-all duration-100 `}
                                                            onClick={() => setFollow({ userId: user.userId, name: user.username })}
                                                        >
                                                            {user.username}
                                                        </div>
                                                    ))
                                                }
                                            </div> : ""
                                    }
                                </div>
                            </div>  
                            <div>
                                <button 
                                    onClick={()=> setShowNewEquation(!showNewEquation)}
                                    className='bg-primary w-[160px] h-[50px] text-white rounded-md ml-6'> 
                                        Add New Equation 
                                </button>
                        
                                <button 
                                className='bg-primary w-[160px] h-[50px] text-white rounded-md ml-6'
                                onClick={updateAgent}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
    )
}